import React from 'react';
import PropTypes, { string } from 'prop-types';
import { StyleSheet, View, ScrollView } from 'react-native-web';

import { Box, Inline } from '@styleseat/ui';
import analytics from '../../../../../modules/analytics';
import Image from '../../../../shared/Image';
import { APP } from '../../../../../config';

import {
  Button,
  HeaderText,
  BodyText,
  Stack,
  Separator,
  Modal,
} from '../../../../ui';

import './ProductSalesEducationModal.module.scss';
import { PROFILE_EDIT_ROUTE } from '../../../../../route-names';

const LionImage = require('../../../../../../images/icons/styleseat-lion-black.svg');

const BLOG_LINK = 'https://www.styleseat.com/blog/sell-products-on-styleseat/';
const styles = StyleSheet.create({
  icon: {
    width: 55,
    height: 55,
  },
  iconContainer: {
    width: 55,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const HeaderImage = ({ source }) => (
  <View style={styles.iconContainer}>
    <Image
      source={source}
      style={styles.icon}
      resizeMode="contain"
    />
  </View>
);

HeaderImage.propTypes = {
  source: string.isRequired,
};

const ProductSalesEducationModal = ({
  onCloseModal,
  providerId,
  ...props
}) => {
  const handleCloseRequest = evt => {
    analytics.track('product_sales_education_modal_dismissed');
    return onCloseModal(evt);
  };

  const handleLearnMoreClick = evt => {
    if (APP) {
      evt.preventDefault();
      window.open(BLOG_LINK, '_system');
    }

    if (typeof onCloseModal === 'function') {
      onCloseModal();
    }
  };

  return (
    <Modal
      showClose
      onCloseRequest={handleCloseRequest}
      theme="blue"
      appearance="fullScreen"
      {...props}
    >
      <ScrollView style={StyleSheet.absoluteFill}>
        <Box paddingX={16} paddingBottom={32}>
          <HeaderImage source={LionImage} />
          <HeaderText theme="notification" level="1">Add a product, boost your sales!</HeaderText>
          <Separator />

          <Box paddingY={16}>
            <Stack space={20}>
              <BodyText appearance="large">
                Now, you can list products on your profile to easily sell your tried-and-true
                recommendations to clients.
              </BodyText>
              <BodyText appearance="large">
                Reach out to your clients to make sure they know!
              </BodyText>
              <Inline>
                <Button
                  onClick={onCloseModal}
                  appearance="primary"
                  size="large"
                  clickTracking="product_sales_education_modal_get_started_clicked"
                  link={PROFILE_EDIT_ROUTE} // TODO(BD): Switch to product create
                  linkParams={{
                    providerId,
                    addProduct: true,
                    clickSource: 'product_sales_education_modal',
                  }}
                >
                  Get Started
                </Button>
              </Inline>
              <Inline>
                <Button
                  styleName="learnMoreButton"
                  onClick={handleLearnMoreClick}
                  size="medium"
                  appearance="link"
                  href={BLOG_LINK}
                  linkTarget="_blank"
                  clickTracking="product_sales_education_modal_learn_more_clicked"
                >
                  Learn More
                </Button>
              </Inline>
            </Stack>
          </Box>
        </Box>
      </ScrollView>
    </Modal>
  );
};

ProductSalesEducationModal.propTypes = {
  onCloseModal: PropTypes.func,
  providerId: PropTypes.number.isRequired,
};

ProductSalesEducationModal.defaultProps = {
  onCloseModal: null,
};

export default ProductSalesEducationModal;
